export default [
  {
    'question-0': {
      id: 'question-0',
      type: 'range',
      correctValue: 100,
      time: 10,
    },
    'question-1': {
      id: 'question-1',
      type: 'boolean',
      correctValue: 0,
      time: 10,
    },
    'question-2': {
      id: 'question-2',
      type: 'list',
      correctValue: 3,
      time: 15,
    },
    'question-3': {
      id: 'question-3',
      type: 'button',
      correctValue: 0,
      time: 10,
    },
  },
  {
    'question-4': {
      id: 'question-4',
      type: 'range',
      correctValue: 100,
      time: 10,
    },
    'question-5': {
      id: 'question-5',
      type: 'boolean',
      correctValue: 0,
      time: 10,
    },
    'question-2': {
      id: 'question-2',
      type: 'list',
      correctValue: 3,
      time: 15,
    },
    'question-7': {
      id: 'question-7',
      type: 'button',
      correctValue: 0,
      time: 15,
    },
  },
  {
    'question-8': {
      id: 'question-8',
      type: 'range',
      correctValue: 100,
      time: 10,
    },
    'question-9': {
      id: 'question-9',
      type: 'boolean',
      correctValue: 0,
      time: 10,
    },
    'question-10': {
      id: 'question-10',
      type: 'list',
      correctValue: 3,
      time: 10,
    },
    'question-11': {
      id: 'question-11',
      type: 'button',
      correctValue: 0,
      time: 15,
    },
  },
];
